import { useQuery, UseQueryOptions } from 'react-query'
import { ApiClient } from 'services/ApiClient'
import { Api } from 'types/Api'
import { getClientId } from 'utils/getClientId'

export namespace FetchProductSubscriptions {
  export type Response = { subscriptionIds: string[] }
  export type Error = Api.Error
  export type Options = UseQueryOptions<Response, Error>
}

const createKey = () => 'bulk-subscriptions'

const queryFetcher = (clientId: string) => () => {
  return ApiClient.get<FetchProductSubscriptions.Response>(
    `/v1/clients/${clientId}/bulk-subscriptions`
  )
}

export const useFetchProductSubscriptions = (options?: FetchProductSubscriptions.Options) => {
  const clientId = getClientId()
  return useQuery<FetchProductSubscriptions.Response, FetchProductSubscriptions.Error>(
    createKey(),
    queryFetcher(clientId!),
    { ...options, enabled: Boolean(clientId) }
  )
}
